import Image from 'next/image';
import React from 'react';

import { make as CustomerReviewCard } from '../../../../ui/components/CustomerReviewCard.mjs';
import { CommonImage } from '../../../../shared/types/CommonVM';
import { CustomerTestimonials } from '../../domain/entities/HomeContentEntity';

import styles from '../styles/CustomerReviews.module.scss';

interface CustomerReviewsCmpProps {
  testimonials_data: CustomerTestimonials;
  wave_icon: CommonImage;
  star_icon: CommonImage;
}

function getOverflowStyle(len: number): string {
  if (len < 4) return styles['min-overflow'];
  if (len === 4) return styles['overflow-4'];
  return '';
}

function CustomerReviewsCmp({
  testimonials_data,
  wave_icon,
  star_icon,
}: CustomerReviewsCmpProps): React.ReactElement | null {
  const { testimonials, title } = testimonials_data;

  if (testimonials.length === 0) return null;

  const overflowStyle = getOverflowStyle(testimonials.length);

  return (
    <div className={styles['container-wrapper']}>
      <div className={styles['title-container']}>
        <Image
          src={wave_icon.path}
          width={50}
          height={8}
          alt={wave_icon.alt_text}
          quality={100}
        />
        {title.length > 0 ? (
          <h2 className={styles['title']}>{title}</h2>
        ) : null}
        <Image
          src={wave_icon.path}
          width={50}
          height={8}
          alt={wave_icon.alt_text}
          quality={100}
        />
      </div>
      <div className={styles['overflow-container']}>
        <div className={`${styles['container']} ${overflowStyle}`}>
          {testimonials.map((testimonial, index) => (
            <CustomerReviewCard
              key={index}
              testimonial={testimonial}
              star_icon={star_icon}
            />
          ))}
        </div>
      </div>
    </div>
  );
}

export default CustomerReviewsCmp;
